// // 'use client';

// // import { useState, useEffect, useRef } from 'react';
// // import Icon from '@/components/ui/AppIcon';
// // import AppImage from '@/components/ui/AppImage';

// // interface DemoCard {
// //   id: string;
// //   title: string;
// //   description: string;
// //   icon: string;
// //   audioUrl: string;
// //   duration: string;
// // }

// // // ========================================
// // // CONFIGURATION - Modify content here
// // // ========================================

// // const SECTION_CONTENT = {
// //   mainHeading: 'Intelligent Automation That Works',
// //   mainSubheading: 'Experience real AI-powered customer conversations',
// //   audioDemo: {
// //     heading: 'Hear How Our AI Handles Real Customer Calls',
// //     subheading: 'Tap on a use case to listen to a real AI Agent–Customer conversation',
// //     trustNote: 'These are real-world AI conversations used by D2C brands to automate customer support.',
// //     disclaimer: 'Note: Audio demos are simulated for this preview. Click play buttons to see the interactive experience.'
// //   },
// //   dashboard: {
// //     heading: 'Real-Time Analytics & Insights'
// //   },
// //   buttons: {
// //     audioCalls: 'Listen to AI Calls',
// //     analytics: 'Analytics Dashboard'
// //   },
// //   playingIndicator: 'Now Playing'
// // };

// // const DEMO_CARDS: DemoCard[] = [
// //   {
// //     id: 'qualification',
// //     title: 'Damaged Product',
// //     description: 'Report damaged product issue',
// //     icon: 'UserGroupIcon',
// //     audioUrl: '/assets/audio/damaged_product.mp3',
// //     duration: '0:45'
// //   },
// //   {
// //     id: 'recommendation',
// //     title: 'Delivery Status',
// //     description: 'Track order delivery updates',
// //     icon: 'ShoppingBagIcon',
// //     audioUrl: '/assets/audio/delivery_status.mp3',
// //     duration: '1:12'
// //   },
// //   {
// //     id: 'bookings',
// //     title: 'Return Request',
// //     description: 'Initiate product return request',
// //     icon: 'CalendarIcon',
// //     audioUrl: '/assets/audio/return_status.mp3',
// //     duration: '0:52'
// //   },
// //   {
// //     id: 'support',
// //     title: 'Refund Status',
// //     description: 'Check refund processing status',
// //     icon: 'LifebuoyIcon',
// //     audioUrl: '/assets/audio/refund_status.mp3',
// //     duration: '1:05'
// //   }
// // ];

// // const ANALYTICS_CARDS = [
// //   {
// //     id: 'conversations',
// //     icon: 'ChatBubbleLeftRightIcon',
// //     iconBgColor: 'bg-primary/10',
// //     iconColor: 'text-primary',
// //     value: '12.4K',
// //     label: 'Conversations Today',
// //     trend: {
// //       icon: 'ArrowTrendingUpIcon',
// //       value: '+18% vs yesterday',
// //       color: 'text-success'
// //     }
// //   },
// //   {
// //     id: 'resolution',
// //     icon: 'CheckCircleIcon',
// //     iconBgColor: 'bg-success/10',
// //     iconColor: 'text-success',
// //     value: '94%',
// //     label: 'Resolution Rate',
// //     trend: {
// //       icon: 'ArrowTrendingUpIcon',
// //       value: '+3% this week',
// //       color: 'text-success'
// //     }
// //   },
// //   {
// //     id: 'response-time',
// //     icon: 'ClockIcon',
// //     iconBgColor: 'bg-accent/10',
// //     iconColor: 'text-accent',
// //     value: '1.8s',
// //     label: 'Avg Response Time',
// //     trend: {
// //       icon: 'ArrowTrendingDownIcon',
// //       value: '-0.4s improved',
// //       color: 'text-success'
// //     }
// //   },
// //   {
// //     id: 'cost-savings',
// //     icon: 'CurrencyDollarIcon',
// //     iconBgColor: 'bg-secondary/10',
// //     iconColor: 'text-secondary',
// //     value: '$89K',
// //     label: 'Cost Savings MTD',
// //     trend: {
// //       icon: 'ArrowTrendingUpIcon',
// //       value: 'On track for $105K',
// //       color: 'text-success'
// //     }
// //   }
// // ];

// // const DASHBOARD_IMAGE = {
// //   src: 'https://img.rocket.new/generatedImages/rocket_gen_img_1638d3f29-1764645307453.png',
// //   alt: 'Modern analytics dashboard showing real-time conversation metrics with colorful charts and graphs'
// // };

// // // ========================================
// // // END CONFIGURATION
// // // ========================================

// // const SolutionSection = () => {
// //   const [isHydrated, setIsHydrated] = useState(false);
// //   const [activeDemo, setActiveDemo] = useState<'audio' | 'dashboard'>('audio');
// //   const [playingDemo, setPlayingDemo] = useState<string | null>(null);
// //   const [isAudioLoading, setIsAudioLoading] = useState(false);
// //   const audioRef = useRef<HTMLAudioElement | null>(null);
// //   const [isPaused, setIsPaused] = useState(false);


// //   // Generate random values once on client side to avoid hydration mismatch
// //   const [waveHeights, setWaveHeights] = useState<number[]>([]);
// //   const [waveDurations, setWaveDurations] = useState<number[]>([]);
// //   const [waveDelays, setWaveDelays] = useState<number[]>([]);

// //    /* 🔽 ADD THIS CLEANUP EFFECT HERE 🔽 */
// // useEffect(() => {
// //   return () => {
// //     stopAndCleanupAudio();
// //   };
// // }, []);

// //   /* 🔼 END CLEANUP EFFECT 🔼 */

// //   useEffect(() => {
// //     setIsHydrated(true);
// //     // Generate random values only on client side after hydration
// //     setWaveHeights(Array.from({ length: 40 }, () => Math.random() * 60 + 20));
// //     setWaveDurations(Array.from({ length: 40 }, () => Math.random() * 2 + 1));
// //     setWaveDelays(Array.from({ length: 40 }, () => Math.random() * 2));
// //   }, []);

// //   // const handlePlayDemo = (demoId: string) => {
// //   //   // Since we don't have actual audio files, just simulate the playing state
// //   //   if (playingDemo === demoId) {
// //   //     setPlayingDemo(null);
// //   //     return;
// //   //   }

// //   //   // Show a message that this is a demo
// //   //   setPlayingDemo(demoId);
    
// //   //   // Auto-stop after duration
// //   //   const demo = DEMO_CARDS.find(d => d.id === demoId);
// //   //   if (demo) {
// //   //     const durationParts = demo.duration.split(':');
// //   //     const seconds = parseInt(durationParts[0]) * 60 + parseInt(durationParts[1]);
// //   //     setTimeout(() => {
// //   //       setPlayingDemo(null);
// //   //     }, seconds * 1000);
// //   //   }
// //   // };

// // //   const handlePlayDemo = (demoId: string) => {
// // //   const demo = DEMO_CARDS.find(d => d.id === demoId);
// // //   if (!demo) return;

// // //   // Stop currently playing audio
// // //   if (audioRef.current) {
// // //     audioRef.current.pause();
// // //     audioRef.current.currentTime = 0;
// // //   }

// // //   // Toggle off if same demo clicked
// // //   // if (playingDemo === demoId) {
// // //   //   setPlayingDemo(null);
// // //   //   return;
// // //   // }

// // //   if (playingDemo === demoId && audioRef.current) {
// // //   if (audioRef.current.paused) {
// // //     audioRef.current.play();
// // //     setIsPaused(false);
// // //   } else {
// // //     audioRef.current.pause();
// // //     setIsPaused(true);
// // //   }
// // //   return;
// // // }


// // //   setIsAudioLoading(true);

// // //   const audio = new Audio(demo.audioUrl);
// // //   audioRef.current = audio;

// // //   audio.oncanplaythrough = () => {
// // //     setIsAudioLoading(false);
// // //     audio.play();
// // //     setPlayingDemo(demoId);
// // //   };

// // //   audio.onended = () => {
// // //     setPlayingDemo(null);
// // //   };

// // //   audio.onerror = () => {
// // //     console.error('Audio failed to load:', demo.audioUrl);
// // //     setIsAudioLoading(false);
// // //     setPlayingDemo(null);
// // //   };
// // // };

// // const stopAndCleanupAudio = () => {
// //   if (!audioRef.current) return;

// //   audioRef.current.pause();
// //   audioRef.current.currentTime = 0;

// //   audioRef.current.onended = null;
// //   audioRef.current.oncanplaythrough = null;
// //   audioRef.current.onerror = null;

// //   audioRef.current.src = '';
// //   audioRef.current.load();

// //   audioRef.current = null;
// // };

// // const handlePlayDemo = (demoId: string) => {
// //   const demo = DEMO_CARDS.find(d => d.id === demoId);
// //   if (!demo) return;

// //   // ▶️ SAME DEMO → TOGGLE PLAY / PAUSE
// //   if (playingDemo === demoId && audioRef.current) {
// //     if (audioRef.current.paused) {
// //       audioRef.current.play();
// //       setIsPaused(false);
// //     } else {
// //       audioRef.current.pause();
// //       setIsPaused(true);
// //     }
// //     return;
// //   }

// //   // 🧹 STOP & DESTROY any existing audio FIRST
// //   stopAndCleanupAudio();

// //   setIsAudioLoading(true);
// //   setIsPaused(false);

// //   const audio = new Audio(demo.audioUrl);
// //   audioRef.current = audio;

// //   audio.oncanplaythrough = () => {
// //     setIsAudioLoading(false);
// //     setPlayingDemo(demoId);
// //     audio.play();
// //   };

// //   audio.onended = () => {
// //     stopAndCleanupAudio();
// //     setPlayingDemo(null);
// //     setIsPaused(false);
// //   };

// //   audio.onerror = () => {
// //     console.error('Audio load failed:', demo.audioUrl);
// //     stopAndCleanupAudio();
// //     setIsAudioLoading(false);
// //     setPlayingDemo(null);
// //     setIsPaused(false);
// //   };
// // };



// // // const handlePlayDemo = (demoId: string) => {
// // //   const demo = DEMO_CARDS.find(d => d.id === demoId);
// // //   if (!demo) return;

// // //   // Same demo clicked → toggle play / pause
// // //   if (playingDemo === demoId && audioRef.current) {
// // //     if (audioRef.current.paused) {
// // //       audioRef.current.play();
// // //       setIsPaused(false);
// // //     } else {
// // //       audioRef.current.pause();
// // //       setIsPaused(true);
// // //     }
// // //     return;
// // //   }

// // //   // Switching to a different demo → stop & reset old audio
// // //   if (audioRef.current) {
// // //     audioRef.current.pause();
// // //     audioRef.current.currentTime = 0;
// // //   }

// // //   setIsAudioLoading(true);
// // //   setIsPaused(false);

// // //   const audio = new Audio(demo.audioUrl);
// // //   audioRef.current = audio;

// // //   audio.oncanplaythrough = () => {
// // //     setIsAudioLoading(false);
// // //     setPlayingDemo(demoId);
// // //     audio.play();
// // //   };

// // //   audio.onended = () => {
// // //     setPlayingDemo(null);
// // //     setIsPaused(false);
// // //   };

// // //   audio.onerror = () => {
// // //     console.error('Failed to load audio:', demo.audioUrl);
// // //     setIsAudioLoading(false);
// // //     setPlayingDemo(null);
// // //     setIsPaused(false);
// // //   };
// // // };


// //   return (
// //     <section id="solutions" className="py-20 md:py-32 bg-gradient-to-b from-surface to-background relative overflow-hidden">
// //       {/* Decorative soundwave elements - only render after hydration to avoid mismatch */}
// //       {isHydrated && (
// //         <div className="absolute inset-0 pointer-events-none">
// //           {/* Top decorative soundwaves */}
// //           <div className="absolute top-0 left-0 right-0 h-32 flex items-center justify-center opacity-10">
// //             <div className="flex items-end gap-2">
// //               {waveHeights.map((height, i) => (
// //                 <div
// //                   key={`top-${i}`}
// //                   className="w-1 bg-gradient-to-t from-blue-500 to-purple-500 rounded-full"
// //                   style={{
// //                     height: `${height}px`,
// //                     animation: `waveform ${waveDurations[i]}s ease-in-out infinite`,
// //                     animationDelay: `${waveDelays[i]}s`
// //                   }}
// //                 />
// //               ))}
// //             </div>
// //           </div>
          
// //           {/* Bottom decorative soundwaves */}
// //           <div className="absolute bottom-0 left-0 right-0 h-32 flex items-center justify-center opacity-10">
// //             <div className="flex items-start gap-2">
// //               {waveHeights.map((height, i) => (
// //                 <div
// //                   key={`bottom-${i}`}
// //                   className="w-1 bg-gradient-to-b from-blue-500 to-purple-500 rounded-full"
// //                   style={{
// //                     height: `${height}px`,
// //                     animation: `waveform ${waveDurations[i]}s ease-in-out infinite`,
// //                     animationDelay: `${waveDelays[i]}s`
// //                   }}
// //                 />
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       <div className="container mx-auto px-4 md:px-6 lg:px-10 relative z-10">
// //         <div className="text-center mb-16">
// //           <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
// //             {SECTION_CONTENT.mainHeading}
// //           </h2>
// //           <p className="text-lg md:text-xl text-text-secondary max-w-3xl mx-auto">
// //             {SECTION_CONTENT.mainSubheading}
// //           </p>
// //         </div>

// //         <div className="mb-8 flex justify-center gap-4">
// //           <button
// //             onClick={() => setActiveDemo('audio')}
// //             className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
// //               activeDemo === 'audio' ?'bg-primary text-primary-foreground shadow-enterprise-md' :'bg-background text-text-secondary hover:bg-muted'
// //             }`}
// //           >
// //             <div className="flex items-center gap-2">
// //               <Icon name="SpeakerWaveIcon" size={20} />
// //               <span>{SECTION_CONTENT.buttons.audioCalls}</span>
// //             </div>
// //           </button>
// //           <button
// //             onClick={() => setActiveDemo('dashboard')}
// //             className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
// //               activeDemo === 'dashboard' ?'bg-primary text-primary-foreground shadow-enterprise-md' :'bg-background text-text-secondary hover:bg-muted'
// //             }`}
// //           >
// //             <div className="flex items-center gap-2">
// //               <Icon name="ChartBarIcon" size={20} />
// //               <span>{SECTION_CONTENT.buttons.analytics}</span>
// //             </div>
// //           </button>
// //         </div>

// //         {activeDemo === 'audio' && (
// //           <div className="max-w-7xl mx-auto">
// //             {/* Section Header */}
// //             <div className="text-center mb-16">
// //               <h3 className="text-2xl md:text-3xl font-bold text-text-primary mb-3">
// //                 {SECTION_CONTENT.audioDemo.heading}
// //               </h3>
// //               <p className="text-base md:text-lg text-text-secondary">
// //                 {SECTION_CONTENT.audioDemo.subheading}
// //               </p>
// //             </div>

// //             {/* Main Demo Area - Redesigned Layout */}
// //             <div className="relative min-h-[400px] flex items-center justify-center">
// //               {/* Central AI Orb - Larger and more prominent */}
// //               <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
// //                 <div className="relative">
// //                   {/* Outer glow rings - more subtle */}
// //                   <div className={`absolute -inset-8 rounded-full bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-blue-500/20 blur-2xl transition-all duration-500 ${
// //                     playingDemo ? 'animate-pulse scale-110' : 'scale-100'
// //                   }`} />
                  
// //                   {/* Main orb - blue to purple gradient */}
// //                   <div className={`relative w-40 h-40 md:w-48 md:h-48 rounded-full bg-gradient-to-br from-blue-500 via-blue-600 to-purple-600 flex items-center justify-center shadow-2xl transition-all duration-300 ${
// //                     playingDemo ? 'scale-110 shadow-blue-500/50' : 'scale-100'
// //                   }`}>
// //                     {/* Waveform animation - use static heights */}
// //                     {playingDemo && !isPaused ? (
// //                       <div className="flex items-center justify-center gap-1.5">
// //                         {[20, 35, 25, 40, 30, 38, 22].map((height, i) => (
// //                           <div
// //                             key={i}
// //                             className="w-1.5 bg-white rounded-full"
// //                             style={{
// //                               animation: 'waveform 1s ease-in-out infinite',
// //                               animationDelay: `${i * 0.1}s`,
// //                               height: `${height}px`
// //                             }}
// //                           />
// //                         ))}
// //                       </div>
// //                     ) : (
// //                       <Icon name="SpeakerWaveIcon" size={56} className="text-white" />
// //                     )}
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* Demo Cards - Positioned around the orb with better spacing */}
// //               <div className="relative w-full max-w-6xl mx-auto">
// //                 {DEMO_CARDS.map((demo, index) => {
// //                   const isActive = playingDemo === demo.id && !isPaused;
// //                   const isLoading = isAudioLoading && playingDemo === demo.id;

// //                   // Position cards around the central orb with better spacing
// //                   // Using a 2x2 grid layout with more space between cards
// //                   const positions = [
// //                     'top-4 left-4 md:left-8', // Top-left - increased spacing
// //                     'top-4 right-4 md:right-8', // Top-right - increased spacing
// //                     'bottom-4 left-4 md:left-8', // Bottom-left - increased spacing
// //                     'bottom-4 right-4 md:right-8' // Bottom-right - increased spacing
// //                   ];

// //                   return (
// //                     <div
// //                       key={demo.id}
// //                       className={`absolute ${positions[index]} w-[calc(50%-120px)] md:w-[calc(50%-180px)] max-w-xs`}
// //                       onClick={() => handlePlayDemo(demo.id)}
// //                     >
// //                       <div
// //                         className={`bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border ${
// //                           isActive
// //                             ? 'border-blue-500 shadow-blue-500/20 scale-105'
// //                             : 'border-gray-100 hover:border-blue-200'
// //                         }`}
// //                       >
// //                         {/* Card Content - Horizontal Layout */}
// //                         <div className="flex items-center gap-4">
// //                           {/* Left: Icon */}
// //                           <div className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
// //                             isActive 
// //                               ? 'bg-blue-600 shadow-lg shadow-blue-500/30' 
// //                               : 'bg-blue-500 hover:bg-blue-600'
// //                           }`}>
// //                             <Icon name={demo.icon as any} size={24} className="text-white" />
// //                           </div>

// //                           {/* Middle: Title and Description */}
// //                           <div className="flex-1 min-w-0">
// //                             <h4 className="text-base font-bold text-gray-900 mb-1 leading-tight">
// //                               {demo.title}
// //                             </h4>
// //                             <p className="text-xs text-gray-600 leading-snug line-clamp-2">
// //                               {demo.description}
// //                             </p>
// //                           </div>

// //                           {/* Right: Play Button */}
// //                           <button
// //                             className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 font-semibold text-xs ${
// //                               isActive
// //                                 ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/30'
// //                                 : 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-md'
// //                             }`}
// //                             onClick={(e) => {
// //                               e.stopPropagation();
// //                               handlePlayDemo(demo.id);
// //                             }}
// //                           >
// //                             {isLoading ? (
// //                               <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
// //                             ) : (
// //                               <div className="flex items-center justify-center gap-1">
// //                                 <Icon name={isActive ? "PauseIcon" : "PlayIcon"} size={16} className="text-white" />
// //                               </div>
// //                             )}
// //                           </button>
// //                         </div>

// //                         {/* Active indicator wave */}
// //                         {isActive && (
// //                           <div className="mt-4 pt-4 border-t border-blue-100">
// //                             <div className="flex items-center justify-between">
// //                               <div className="flex items-center gap-2">
// //                                 <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" />
// //                                 <span className="text-xs font-semibold text-blue-600">
// //                                   {SECTION_CONTENT.playingIndicator}
// //                                 </span>
// //                               </div>
// //                               <span className="text-xs text-gray-500 font-medium">
// //                                 {demo.duration}
// //                               </span>
// //                             </div>
// //                           </div>
// //                         )}
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>

// //             {/* Trust Note with demo disclaimer */}
// //             <div className="mt-16 text-center space-y-3">
// //               <p className="text-sm text-text-secondary max-w-2xl mx-auto italic">
// //                 {SECTION_CONTENT.audioDemo.trustNote}
// //               </p>
// //               <p className="text-xs text-muted-foreground max-w-xl mx-auto">
// //                 {SECTION_CONTENT.audioDemo.disclaimer}
// //               </p>
// //             </div>
// //           </div>
// //         )}

// //         {activeDemo === 'dashboard' && (
// //           <div className="max-w-6xl mx-auto">
// //             <div className="bg-background rounded-2xl shadow-enterprise-md overflow-hidden">
// //               <div className="relative">
// //                 <AppImage
// //                   src={DASHBOARD_IMAGE.src}
// //                   alt={DASHBOARD_IMAGE.alt}
// //                   className="w-full h-auto"
// //                 />
// //                 <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
// //               </div>

// //               <div className="p-8">
// //                 <h3 className="text-2xl font-bold text-text-primary mb-6">
// //                   {SECTION_CONTENT.dashboard.heading}
// //                 </h3>

// //                 <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
// //                   {ANALYTICS_CARDS.map((card) => (
// //                     <div key={card.id} className="bg-surface rounded-xl p-6 border border-border">
// //                       <div className="flex items-center gap-3 mb-3">
// //                         <div className={`w-10 h-10 ${card.iconBgColor} rounded-lg flex items-center justify-center`}>
// //                           <Icon name={card.icon as any} size={24} className={card.iconColor} />
// //                         </div>
// //                         <div className="text-3xl font-bold text-text-primary">{card.value}</div>
// //                       </div>
// //                       <p className="text-sm text-text-secondary">{card.label}</p>
// //                       <div className="flex items-center gap-1 mt-2">
// //                         <Icon name={card.trend.icon as any} size={16} className={card.trend.color} />
// //                         <span className={`text-xs font-semibold ${card.trend.color}`}>
// //                           {card.trend.value}
// //                         </span>
// //                       </div>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //     </section>
// //   );
// // };

// // export default SolutionSection;

// 'use client';

// import { useState, useEffect, useRef } from 'react';
// import Icon from '@/components/ui/AppIcon';
// import AppImage from '@/components/ui/AppImage';

// interface DemoCard {
//   id: string;
//   title: string;
//   description: string;
//   icon: string;
//   audioUrl: string;
//   duration: string;
// }

// // ========================================
// // CONFIGURATION - Modify content here
// // ========================================

// const SECTION_CONTENT = {
//   mainHeading: 'Intelligent Automation That Works',
//   mainSubheading: 'Experience real AI-powered customer conversations',
//   audioDemo: {
//     heading: 'Hear How Our AI Handles Real Customer Calls',
//     subheading: 'Tap on a use case to listen to a real AI Agent–Customer conversation',
//     trustNote: 'These are real-world AI conversations used by D2C brands to automate customer support.',
//     disclaimer: 'Note: Audio demos are simulated for this preview. Click play buttons to see the interactive experience.'
//   },
//   dashboard: {
//     heading: 'Real-Time Analytics & Insights'
//   },
//   buttons: {
//     audioCalls: 'Listen to AI Calls',
//     analytics: 'Analytics Dashboard'
//   },
//   playingIndicator: 'Now Playing'
// };

// const DEMO_CARDS: DemoCard[] = [
//   {
//     id: 'qualification',
//     title: 'Damaged Product',
//     description: 'Report damaged product issue',
//     icon: 'UserGroupIcon',
//     audioUrl: '/assets/audio/damaged_product.mp3',
//     duration: '0:45'
//   },
//   {
//     id: 'recommendation',
//     title: 'Delivery Status',
//     description: 'Track order delivery updates',
//     icon: 'ShoppingBagIcon',
//     audioUrl: '/assets/audio/delivery_status.mp3',
//     duration: '1:12'
//   },
//   {
//     id: 'bookings',
//     title: 'Return Request',
//     description: 'Initiate product return request',
//     icon: 'CalendarIcon',
//     audioUrl: '/assets/audio/return_status.mp3',
//     duration: '0:52'
//   },
//   {
//     id: 'support',
//     title: 'Refund Status',
//     description: 'Check refund processing status',
//     icon: 'LifebuoyIcon',
//     audioUrl: '/assets/audio/refund_status.mp3',
//     duration: '1:05'
//   }
// ];

// const ANALYTICS_CARDS = [
//   {
//     id: 'conversations',
//     icon: 'ChatBubbleLeftRightIcon',
//     iconBgColor: 'bg-primary/10',
//     iconColor: 'text-primary',
//     value: '12.4K',
//     label: 'Conversations Today',
//     trend: {
//       icon: 'ArrowTrendingUpIcon',
//       value: '+18% vs yesterday',
//       color: 'text-success'
//     }
//   },
//   {
//     id: 'resolution',
//     icon: 'CheckCircleIcon',
//     iconBgColor: 'bg-success/10',
//     iconColor: 'text-success',
//     value: '94%',
//     label: 'Resolution Rate',
//     trend: {
//       icon: 'ArrowTrendingUpIcon',
//       value: '+3% this week',
//       color: 'text-success'
//     }
//   },
//   {
//     id: 'response-time',
//     icon: 'ClockIcon',
//     iconBgColor: 'bg-accent/10',
//     iconColor: 'text-accent',
//     value: '1.8s',
//     label: 'Avg Response Time',
//     trend: {
//       icon: 'ArrowTrendingDownIcon',
//       value: '-0.4s improved',
//       color: 'text-success'
//     }
//   },
//   {
//     id: 'cost-savings',
//     icon: 'CurrencyDollarIcon',
//     iconBgColor: 'bg-secondary/10',
//     iconColor: 'text-secondary',
//     value: '$89K',
//     label: 'Cost Savings MTD',
//     trend: {
//       icon: 'ArrowTrendingUpIcon',
//       value: 'On track for $105K',
//       color: 'text-success'
//     }
//   }
// ];

// const DASHBOARD_IMAGE = {
//   src: 'https://img.rocket.new/generatedImages/rocket_gen_img_1638d3f29-1764645307453.png',
//   alt: 'Modern analytics dashboard showing real-time conversation metrics with colorful charts and graphs'
// };

// // ========================================
// // END CONFIGURATION
// // ========================================

// const SolutionSection = () => {
//   const [isHydrated, setIsHydrated] = useState(false);
//   const [activeDemo, setActiveDemo] = useState<'audio' | 'dashboard'>('audio');
//   const [playingDemo, setPlayingDemo] = useState<string | null>(null);
//   const [isAudioLoading, setIsAudioLoading] = useState(false);
//   const audioRef = useRef<HTMLAudioElement | null>(null);
//   const [isPaused, setIsPaused] = useState(false);

//   // Generate random values once on client side to avoid hydration mismatch
//   const [waveHeights, setWaveHeights] = useState<number[]>([]);
//   const [waveDurations, setWaveDurations] = useState<number[]>([]);
//   const [waveDelays, setWaveDelays] = useState<number[]>([]);

//   // Cleanup effect
//   useEffect(() => {
//     return () => {
//       stopAndCleanupAudio();
//     };
//   }, []);

//   useEffect(() => {
//     setIsHydrated(true);
//     // Generate random values only on client side after hydration
//     setWaveHeights(Array.from({ length: 40 }, () => Math.random() * 60 + 20));
//     setWaveDurations(Array.from({ length: 40 }, () => Math.random() * 2 + 1));
//     setWaveDelays(Array.from({ length: 40 }, () => Math.random() * 2));
//   }, []);

//   const stopAndCleanupAudio = () => {
//     if (!audioRef.current) return;

//     audioRef.current.pause();
//     audioRef.current.currentTime = 0;

//     audioRef.current.onended = null;
//     audioRef.current.oncanplaythrough = null;
//     audioRef.current.onerror = null;

//     audioRef.current.src = '';
//     audioRef.current.load();

//     audioRef.current = null;
//   };

//   const handlePlayDemo = (demoId: string) => {
//     const demo = DEMO_CARDS.find(d => d.id === demoId);
//     if (!demo) return;

//     // Same demo → toggle play / pause
//     if (playingDemo === demoId && audioRef.current) {
//       if (audioRef.current.paused) {
//         audioRef.current.play();
//         setIsPaused(false);
//       } else {
//         audioRef.current.pause();
//         setIsPaused(true);
//       }
//       return;
//     }

//     // Stop & destroy any existing audio first
//     stopAndCleanupAudio();

//     setIsAudioLoading(true);
//     setIsPaused(false);

//     const audio = new Audio(demo.audioUrl);
//     audioRef.current = audio;

//     audio.oncanplaythrough = () => {
//       setIsAudioLoading(false);
//       setPlayingDemo(demoId);
//       audio.play();
//     };

//     audio.onended = () => {
//       stopAndCleanupAudio();
//       setPlayingDemo(null);
//       setIsPaused(false);
//     };

//     audio.onerror = () => {
//       console.error('Audio load failed:', demo.audioUrl);
//       stopAndCleanupAudio();
//       setIsAudioLoading(false);
//       setPlayingDemo(null);
//       setIsPaused(false);
//     };
//   };

//   return (
//     <section id="solutions" className="py-20 md:py-32 bg-gradient-to-b from-surface to-background relative overflow-hidden">
//       {/* Decorative soundwave elements - only render after hydration to avoid mismatch */}
//       {isHydrated && (
//         <div className="absolute inset-0 pointer-events-none">
//           {/* Top decorative soundwaves */}
//           <div className="absolute top-0 left-0 right-0 h-32 flex items-center justify-center opacity-10">
//             <div className="flex items-end gap-2">
//               {waveHeights.map((height, i) => (
//                 <div
//                   key={`top-${i}`}
//                   className="w-1 bg-gradient-to-t from-blue-500 to-purple-500 rounded-full"
//                   style={{
//                     height: `${height}px`,
//                     animation: `waveform ${waveDurations[i]}s ease-in-out infinite`,
//                     animationDelay: `${waveDelays[i]}s`
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
          
//           {/* Bottom decorative soundwaves */}
//           <div className="absolute bottom-0 left-0 right-0 h-32 flex items-center justify-center opacity-10">
//             <div className="flex items-start gap-2">
//               {waveHeights.map((height, i) => (
//                 <div
//                   key={`bottom-${i}`}
//                   className="w-1 bg-gradient-to-b from-blue-500 to-purple-500 rounded-full"
//                   style={{
//                     height: `${height}px`,
//                     animation: `waveform ${waveDurations[i]}s ease-in-out infinite`,
//                     animationDelay: `${waveDelays[i]}s`
//                   }}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="container mx-auto px-4 md:px-6 lg:px-10 relative z-10">
//         <div className="text-center mb-16">
//           <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
//             {SECTION_CONTENT.mainHeading}
//           </h2>
//           <p className="text-lg md:text-xl text-text-secondary max-w-3xl mx-auto">
//             {SECTION_CONTENT.mainSubheading}
//           </p>
//         </div>

//         <div className="mb-8 flex justify-center gap-4">
//           <button
//             onClick={() => setActiveDemo('audio')}
//             className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
//               activeDemo === 'audio' ? 'bg-primary text-primary-foreground shadow-enterprise-md' : 'bg-background text-text-secondary hover:bg-muted'
//             }`}
//           >
//             <div className="flex items-center gap-2">
//               <Icon name="SpeakerWaveIcon" size={20} />
//               <span>{SECTION_CONTENT.buttons.audioCalls}</span>
//             </div>
//           </button>
//           <button
//             onClick={() => setActiveDemo('dashboard')}
//             className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
//               activeDemo === 'dashboard' ? 'bg-primary text-primary-foreground shadow-enterprise-md' : 'bg-background text-text-secondary hover:bg-muted'
//             }`}
//           >
//             <div className="flex items-center gap-2">
//               <Icon name="ChartBarIcon" size={20} />
//               <span>{SECTION_CONTENT.buttons.analytics}</span>
//             </div>
//           </button>
//         </div>

//         {activeDemo === 'audio' && (
//           <div className="max-w-7xl mx-auto">
//             {/* Section Header */}
//             <div className="text-center mb-16">
//               <h3 className="text-2xl md:text-3xl font-bold text-text-primary mb-3">
//                 {SECTION_CONTENT.audioDemo.heading}
//               </h3>
//               <p className="text-base md:text-lg text-text-secondary">
//                 {SECTION_CONTENT.audioDemo.subheading}
//               </p>
//             </div>

//             {/* Main Demo Area - Vertical Stack for Mobile, Orb Layout for Desktop */}
//             <div>
//               {/* Desktop Layout - Original Orb Design (hidden on mobile) */}
//               <div className="hidden md:block relative min-h-[400px]">
//                 {/* Central AI Orb */}
//                 <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
//                   <div className="relative">
//                     {/* Outer glow rings */}
//                     <div className={`absolute -inset-8 rounded-full bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-blue-500/20 blur-2xl transition-all duration-500 ${
//                       playingDemo ? 'animate-pulse scale-110' : 'scale-100'
//                     }`} />
                    
//                     {/* Main orb */}
//                     <div className={`relative w-48 h-48 rounded-full bg-gradient-to-br from-blue-500 via-blue-600 to-purple-600 flex items-center justify-center shadow-2xl transition-all duration-300 ${
//                       playingDemo ? 'scale-110 shadow-blue-500/50' : 'scale-100'
//                     }`}>
//                       {/* Waveform animation */}
//                       {playingDemo && !isPaused ? (
//                         <div className="flex items-center justify-center gap-1.5">
//                           {[20, 35, 25, 40, 30, 38, 22].map((height, i) => (
//                             <div
//                               key={i}
//                               className="w-1.5 bg-white rounded-full"
//                               style={{
//                                 animation: 'waveform 1s ease-in-out infinite',
//                                 animationDelay: `${i * 0.1}s`,
//                                 height: `${height}px`
//                               }}
//                             />
//                           ))}
//                         </div>
//                       ) : (
//                         <Icon name="SpeakerWaveIcon" size={56} className="text-white" />
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Demo Cards - Desktop Position */}
//                 <div className="relative w-full max-w-6xl mx-auto">
//                   {DEMO_CARDS.map((demo, index) => {
//                     const isActive = playingDemo === demo.id && !isPaused;
//                     const isLoading = isAudioLoading && playingDemo === demo.id;

//                     const positions = [
//                       'top-4 left-8',
//                       'top-4 right-8',
//                       'bottom-4 left-8',
//                       'bottom-4 right-8'
//                     ];

//                     return (
//                       <div
//                         key={demo.id}
//                         className={`absolute ${positions[index]} w-[calc(50%-180px)] max-w-xs`}
//                         onClick={() => handlePlayDemo(demo.id)}
//                       >
//                         <div
//                           className={`bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border ${
//                             isActive
//                               ? 'border-blue-500 shadow-blue-500/20 scale-105'
//                               : 'border-gray-100 hover:border-blue-200'
//                           }`}
//                         >
//                           <div className="flex items-center gap-4">
//                             <div className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
//                               isActive 
//                                 ? 'bg-blue-600 shadow-lg shadow-blue-500/30' 
//                                 : 'bg-blue-500 hover:bg-blue-600'
//                             }`}>
//                               <Icon name={demo.icon as any} size={24} className="text-white" />
//                             </div>

//                             <div className="flex-1 min-w-0">
//                               <h4 className="text-base font-bold text-gray-900 mb-1 leading-tight">
//                                 {demo.title}
//                               </h4>
//                               <p className="text-xs text-gray-600 leading-snug line-clamp-2">
//                                 {demo.description}
//                               </p>
//                             </div>

//                             <button
//                               className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
//                                 isActive
//                                   ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/30'
//                                   : 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-md'
//                               }`}
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 handlePlayDemo(demo.id);
//                               }}
//                             >
//                               {isLoading ? (
//                                 <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                               ) : (
//                                 <Icon name={isActive ? "PauseIcon" : "PlayIcon"} size={16} className="text-white" />
//                               )}
//                             </button>
//                           </div>

//                           {isActive && (
//                             <div className="mt-4 pt-4 border-t border-blue-100">
//                               <div className="flex items-center justify-between">
//                                 <div className="flex items-center gap-2">
//                                   <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" />
//                                   <span className="text-xs font-semibold text-blue-600">
//                                     {SECTION_CONTENT.playingIndicator}
//                                   </span>
//                                 </div>
//                                 <span className="text-xs text-gray-500 font-medium">
//                                   {demo.duration}
//                                 </span>
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>

//               {/* Mobile Layout - Vertical Stack (visible only on mobile) */}
//               <div className="md:hidden space-y-4">
//                 {/* Central AI Orb for Mobile */}
//                 <div className="flex justify-center mb-8">
//                   <div className="relative">
//                     <div className={`absolute -inset-6 rounded-full bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-blue-500/20 blur-xl transition-all duration-500 ${
//                       playingDemo ? 'animate-pulse scale-110' : 'scale-100'
//                     }`} />
                    
//                     <div className={`relative w-32 h-32 rounded-full bg-gradient-to-br from-blue-500 via-blue-600 to-purple-600 flex items-center justify-center shadow-2xl transition-all duration-300 ${
//                       playingDemo ? 'scale-110 shadow-blue-500/50' : 'scale-100'
//                     }`}>
//                       {playingDemo && !isPaused ? (
//                         <div className="flex items-center justify-center gap-1">
//                           {[20, 35, 25, 40, 30, 38, 22].map((height, i) => (
//                             <div
//                               key={i}
//                               className="w-1 bg-white rounded-full"
//                               style={{
//                                 animation: 'waveform 1s ease-in-out infinite',
//                                 animationDelay: `${i * 0.1}s`,
//                                 height: `${height}px`
//                               }}
//                             />
//                           ))}
//                         </div>
//                       ) : (
//                         <Icon name="SpeakerWaveIcon" size={48} className="text-white" />
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Vertically Stacked Demo Cards */}
//                 {DEMO_CARDS.map((demo) => {
//                   const isActive = playingDemo === demo.id && !isPaused;
//                   const isLoading = isAudioLoading && playingDemo === demo.id;

//                   return (
//                     <div
//                       key={demo.id}
//                       onClick={() => handlePlayDemo(demo.id)}
//                       className={`bg-white rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border ${
//                         isActive
//                           ? 'border-blue-500 shadow-blue-500/20 scale-[1.02]'
//                           : 'border-gray-100 hover:border-blue-200'
//                       }`}
//                     >
//                       <div className="flex items-center gap-4">
//                         <div className={`flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 ${
//                           isActive 
//                             ? 'bg-blue-600 shadow-lg shadow-blue-500/30' 
//                             : 'bg-blue-500 hover:bg-blue-600'
//                         }`}>
//                           <Icon name={demo.icon as any} size={24} className="text-white" />
//                         </div>

//                         <div className="flex-1 min-w-0">
//                           <h4 className="text-base font-bold text-gray-900 mb-1">
//                             {demo.title}
//                           </h4>
//                           <p className="text-sm text-gray-600">
//                             {demo.description}
//                           </p>
//                         </div>

//                         <button
//                           className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
//                             isActive
//                               ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/30'
//                               : 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-md'
//                           }`}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             handlePlayDemo(demo.id);
//                           }}
//                         >
//                           {isLoading ? (
//                             <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
//                           ) : (
//                             <Icon name={isActive ? "PauseIcon" : "PlayIcon"} size={18} className="text-white" />
//                           )}
//                         </button>
//                       </div>

//                       {isActive && (
//                         <div className="mt-4 pt-4 border-t border-blue-100">
//                           <div className="flex items-center justify-between">
//                             <div className="flex items-center gap-2">
//                               <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" />
//                               <span className="text-xs font-semibold text-blue-600">
//                                 {SECTION_CONTENT.playingIndicator}
//                               </span>
//                             </div>
//                             <span className="text-xs text-gray-500 font-medium">
//                               {demo.duration}
//                             </span>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             {/* Trust Note with demo disclaimer */}
//             <div className="mt-16 text-center space-y-3">
//               <p className="text-sm text-text-secondary max-w-2xl mx-auto italic">
//                 {SECTION_CONTENT.audioDemo.trustNote}
//               </p>
//               <p className="text-xs text-muted-foreground max-w-xl mx-auto">
//                 {SECTION_CONTENT.audioDemo.disclaimer}
//               </p>
//             </div>
//           </div>
//         )}

//         {activeDemo === 'dashboard' && (
//           <div className="max-w-6xl mx-auto">
//             <div className="bg-background rounded-2xl shadow-enterprise-md overflow-hidden">
//               <div className="relative">
//                 <AppImage
//                   src={DASHBOARD_IMAGE.src}
//                   alt={DASHBOARD_IMAGE.alt}
//                   className="w-full h-auto"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
//               </div>

//               <div className="p-8">
//                 <h3 className="text-2xl font-bold text-text-primary mb-6">
//                   {SECTION_CONTENT.dashboard.heading}
//                 </h3>

//                 <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//                   {ANALYTICS_CARDS.map((card) => (
//                     <div key={card.id} className="bg-surface rounded-xl p-6 border border-border">
//                       <div className="flex items-center gap-3 mb-3">
//                         <div className={`w-10 h-10 ${card.iconBgColor} rounded-lg flex items-center justify-center`}>
//                           <Icon name={card.icon as any} size={24} className={card.iconColor} />
//                         </div>
//                         <div className="text-3xl font-bold text-text-primary">{card.value}</div>
//                       </div>
//                       <p className="text-sm text-text-secondary">{card.label}</p>
//                       <div className="flex items-center gap-1 mt-2">
//                         <Icon name={card.trend.icon as any} size={16} className={card.trend.color} />
//                         <span className={`text-xs font-semibold ${card.trend.color}`}>
//                           {card.trend.value}
//                         </span>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default SolutionSection;

'use client';

import { useState, useEffect, useRef } from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface DemoCard {
  id: string;
  title: string;
  description: string;
  icon: string;
  audioUrl: string;
  duration: string;
}

// ========================================
// CONFIGURATION - Modify content here
// ========================================

const SECTION_CONTENT = {
  mainHeading: 'Intelligent Automation That Works',
  mainSubheading: 'Experience real AI-powered customer conversations',
  audioDemo: {
    heading: 'Hear How Our AI Handles Real Customer Calls',
    subheading: 'Tap on a use case to listen to a real AI Agent–Customer conversation',
    trustNote: 'These are real-world AI conversations used by D2C brands to automate customer support.',
    disclaimer: 'Note: Audio demos are simulated for this preview. Click play buttons to see the interactive experience.'
  },
  dashboard: {
    heading: 'Real-Time Analytics & Insights'
  },
  buttons: {
    audioCalls: 'Listen to AI Calls',
    analytics: 'Analytics Dashboard'
  },
  playingIndicator: 'Now Playing'
};

const DEMO_CARDS: DemoCard[] = [
  {
    id: 'qualification',
    title: 'Damaged Product',
    description: 'Report damaged product issue',
    icon: 'ExclamationTriangleIcon',
    audioUrl: '/assets/audio/damaged_product.mp3',
    duration: '0:45'
  },
  {
    id: 'recommendation',
    title: 'Delivery Status',
    description: 'Track order delivery updates',
    icon: 'TruckIcon',
    audioUrl: '/assets/audio/delivery_status.mp3',
    duration: '1:12'
  },
  {
    id: 'bookings',
    title: 'Return Request',
    description: 'Initiate product return request',
    icon: 'ArrowUturnLeftIcon',
    audioUrl: '/assets/audio/return_status.mp3',
    duration: '0:52'
  },
  {
    id: 'support',
    title: 'Refund Status',
    description: 'Check refund processing status',
    icon: 'BanknotesIcon',
    audioUrl: '/assets/audio/refund_status.mp3',
    duration: '1:05'
  }
];

const ANALYTICS_CARDS = [
  {
    id: 'conversations',
    icon: 'ChatBubbleLeftRightIcon',
    iconBgColor: 'bg-primary/10',
    iconColor: 'text-primary',
    value: '12.4K',
    label: 'Conversations Today',
    trend: {
      icon: 'ArrowTrendingUpIcon',
      value: '+18% vs yesterday',
      color: 'text-success'
    }
  },
  {
    id: 'resolution',
    icon: 'CheckCircleIcon',
    iconBgColor: 'bg-success/10',
    iconColor: 'text-success',
    value: '94%',
    label: 'Resolution Rate',
    trend: {
      icon: 'ArrowTrendingUpIcon',
      value: '+3% this week',
      color: 'text-success'
    }
  },
  {
    id: 'response-time',
    icon: 'ClockIcon',
    iconBgColor: 'bg-accent/10',
    iconColor: 'text-accent',
    value: '55s',
    label: 'Avg Call Duration',
    trend: {
      icon: 'ArrowTrendingDownIcon',
      value: '-5s improved',
      color: 'text-success'
    }
  },
  {
    id: 'cost-savings',
    icon: 'CheckCircleIcon',
    iconBgColor: 'bg-secondary/10',
    iconColor: 'text-secondary',
    value: '8%',
    label: 'Human Escalation',
    trend: {
      icon: 'ArrowTrendingDownIcon',
      value: '-3% improved',
      color: 'text-success'
    }
  }
];

const DASHBOARD_IMAGE = {
  src: 'https://img.rocket.new/generatedImages/rocket_gen_img_1638d3f29-1764645307453.png',
  alt: 'Modern analytics dashboard showing real-time conversation metrics with colorful charts and graphs'
};

// ========================================
// END CONFIGURATION
// ========================================

const SolutionSection = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [activeDemo, setActiveDemo] = useState<'audio' | 'dashboard'>('audio');
  const [playingDemo, setPlayingDemo] = useState<string | null>(null);
  const [isAudioLoading, setIsAudioLoading] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPaused, setIsPaused] = useState(false);

  // Generate random values once on client side to avoid hydration mismatch
  const [waveHeights, setWaveHeights] = useState<number[]>([]);
  const [waveDurations, setWaveDurations] = useState<number[]>([]);
  const [waveDelays, setWaveDelays] = useState<number[]>([]);

  // Cleanup effect
  useEffect(() => {
    return () => {
      stopAndCleanupAudio();
    };
  }, []);

  useEffect(() => {
    setIsHydrated(true);
    // Generate random values only on client side after hydration
    setWaveHeights(Array.from({ length: 40 }, () => Math.random() * 60 + 20));
    setWaveDurations(Array.from({ length: 40 }, () => Math.random() * 2 + 1));
    setWaveDelays(Array.from({ length: 40 }, () => Math.random() * 2));
  }, []);

  const stopAndCleanupAudio = () => {
    if (!audioRef.current) return;

    audioRef.current.pause();
    audioRef.current.currentTime = 0;

    audioRef.current.onended = null;
    audioRef.current.oncanplaythrough = null;
    audioRef.current.onerror = null;

    audioRef.current.src = '';
    audioRef.current.load();

    audioRef.current = null;
  };

  const handlePlayDemo = (demoId: string) => {
    const demo = DEMO_CARDS.find(d => d.id === demoId);
    if (!demo) return;

    // Same demo → toggle play / pause
    if (playingDemo === demoId && audioRef.current) {
      if (audioRef.current.paused) {
        audioRef.current.play();
        setIsPaused(false);
      } else {
        audioRef.current.pause();
        setIsPaused(true);
      }
      return;
    }

    // Stop & destroy any existing audio first
    stopAndCleanupAudio();

    setIsAudioLoading(true);
    setIsPaused(false);

    const audio = new Audio(demo.audioUrl);
    audioRef.current = audio;

    audio.oncanplaythrough = () => {
      setIsAudioLoading(false);
      setPlayingDemo(demoId);
      audio.play();
    };

    audio.onended = () => {
      stopAndCleanupAudio();
      setPlayingDemo(null);
      setIsPaused(false);
    };

    audio.onerror = () => {
      console.error('Audio load failed:', demo.audioUrl);
      stopAndCleanupAudio();
      setIsAudioLoading(false);
      setPlayingDemo(null);
      setIsPaused(false);
    };
  };

  return (
    <section data-component-id="src/app/landing-page/components/SolutionSection.tsx:1460:4" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1460" data-component-end-line="1832" data-component-file="SolutionSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22solutions%22%2C%22className%22%3A%22pt-20%20md%3Apt-32%20pb-28%20md%3Apb-40%20bg-gradient-to-b%20from-surface%20to-background%20relative%20overflow-hidden%22%7D" id="solutions" className="pt-20 md:pt-32 pb-28 md:pb-40 bg-gradient-to-b from-surface to-background relative overflow-hidden">
      {/* Decorative soundwave elements - only render after hydration to avoid mismatch */}
      {isHydrated && (
<div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1463:0" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1463" data-component-end-line="1500" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-x-0%20top-0%20bottom-0%20pointer-events-none%20overflow-hidden%22%7D" className="absolute inset-x-0 top-0 bottom-0 pointer-events-none overflow-hidden">

          {/* Top decorative soundwaves */}
<div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1466:0" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1466" data-component-end-line="1481" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-0%20left-0%20right-0%20h-24%20flex%20items-start%20justify-center%20opacity-10%22%7D" className="absolute top-0 left-0 right-0 h-24 flex items-start justify-center opacity-10">

            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1468:12" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1468" data-component-end-line="1480" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-end%20gap-2%22%7D" className="flex items-end gap-2">
              {waveHeights.map((height, i) => (
                <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1470:16" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1470" data-component-end-line="1478" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-1%20bg-gradient-to-t%20from-blue-500%20to-purple-500%20rounded-full%22%7D"
                  key={`top-${i}`}
                  className="w-1 bg-gradient-to-t from-blue-500 to-purple-500 rounded-full"
                  style={{
                    height: `${height}px`,
                    animation: `waveform ${waveDurations[i]}s ease-in-out infinite`,
                    animationDelay: `${waveDelays[i]}s`
                  }}
                />
              ))}
            </div>
          </div>
          
          {/* Bottom decorative soundwaves */}
<div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1484:0" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1484" data-component-end-line="1499" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20bottom-0%20left-0%20right-0%20h-24%20flex%20items-end%20justify-center%20opacity-10%22%7D" className="absolute bottom-0 left-0 right-0 h-24 flex items-end justify-center opacity-10">

            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1486:12" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1486" data-component-end-line="1498" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20gap-2%22%7D" className="flex items-start gap-2">
              {waveHeights.map((height, i) => (
                <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1488:16" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1488" data-component-end-line="1496" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-1%20bg-gradient-to-b%20from-blue-500%20to-purple-500%20rounded-full%22%7D"
                  key={`bottom-${i}`}
                  className="w-1 bg-gradient-to-b from-blue-500 to-purple-500 rounded-full"
                  style={{
                    height: `${height}px`,
                    animation: `waveform ${waveDurations[i]}s ease-in-out infinite`,
                    animationDelay: `${waveDelays[i]}s`
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1503:6" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1503" data-component-end-line="1831" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20md%3Apx-6%20lg%3Apx-10%20relative%20z-10%22%7D" className="container mx-auto px-4 md:px-6 lg:px-10 relative z-10">
        <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1504:8" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1504" data-component-end-line="1511" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-16%22%7D" className="text-center mb-16">
          <h2 data-component-id="src/app/landing-page/components/SolutionSection.tsx:1505:10" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1505" data-component-end-line="1507" data-component-file="SolutionSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20md%3Atext-4xl%20lg%3Atext-5xl%20font-bold%20text-text-primary%20mb-4%22%7D" className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-4">
            {SECTION_CONTENT.mainHeading}
          </h2>
          <p data-component-id="src/app/landing-page/components/SolutionSection.tsx:1508:10" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1508" data-component-end-line="1510" data-component-file="SolutionSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-lg%20md%3Atext-xl%20text-text-secondary%20max-w-3xl%20mx-auto%22%7D" className="text-lg md:text-xl text-text-secondary max-w-3xl mx-auto">
            {SECTION_CONTENT.mainSubheading}
          </p>
        </div>

        <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1513:8" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1513" data-component-end-line="1536" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-8%20flex%20justify-center%20gap-4%22%7D" className="mb-8 flex justify-center gap-4">
          <button data-component-id="src/app/landing-page/components/SolutionSection.tsx:1514:10" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1514" data-component-end-line="1524" data-component-file="SolutionSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            onClick={() => setActiveDemo('audio')}
            className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
              activeDemo === 'audio' ? 'bg-primary text-primary-foreground shadow-enterprise-md' : 'bg-background text-text-secondary hover:bg-muted'
            }`}
          >
            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1520:12" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1520" data-component-end-line="1523" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-2%22%7D" className="flex items-center gap-2">
              <Icon data-component-id="src/app/landing-page/components/SolutionSection.tsx:1521:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1521" data-component-end-line="1521" data-component-file="SolutionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22SpeakerWaveIcon%22%7D" name="SpeakerWaveIcon" size={20} />
              <span data-component-id="src/app/landing-page/components/SolutionSection.tsx:1522:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1522" data-component-end-line="1522" data-component-file="SolutionSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{SECTION_CONTENT.buttons.audioCalls}</span>
            </div>
          </button>
          <button data-component-id="src/app/landing-page/components/SolutionSection.tsx:1525:10" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1525" data-component-end-line="1535" data-component-file="SolutionSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            onClick={() => setActiveDemo('dashboard')}
            className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 ${
              activeDemo === 'dashboard' ? 'bg-primary text-primary-foreground shadow-enterprise-md' : 'bg-background text-text-secondary hover:bg-muted'
            }`}
          >
            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1531:12" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1531" data-component-end-line="1534" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-2%22%7D" className="flex items-center gap-2">
              <Icon data-component-id="src/app/landing-page/components/SolutionSection.tsx:1532:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1532" data-component-end-line="1532" data-component-file="SolutionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChartBarIcon%22%7D" name="ChartBarIcon" size={20} />
              <span data-component-id="src/app/landing-page/components/SolutionSection.tsx:1533:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1533" data-component-end-line="1533" data-component-file="SolutionSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{SECTION_CONTENT.buttons.analytics}</span>
            </div>
          </button>
        </div>

        {activeDemo === 'audio' && (
          <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1539:10" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1539" data-component-end-line="1788" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%22%7D" className="max-w-7xl mx-auto">
            {/* Section Header */}
            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1541:12" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1541" data-component-end-line="1548" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-16%22%7D" className="text-center mb-16">
              <h3 data-component-id="src/app/landing-page/components/SolutionSection.tsx:1542:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1542" data-component-end-line="1544" data-component-file="SolutionSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-2xl%20md%3Atext-3xl%20font-bold%20text-text-primary%20mb-3%22%7D" className="text-2xl md:text-3xl font-bold text-text-primary mb-3">
                {SECTION_CONTENT.audioDemo.heading}
              </h3>
              <p data-component-id="src/app/landing-page/components/SolutionSection.tsx:1545:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1545" data-component-end-line="1547" data-component-file="SolutionSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-base%20md%3Atext-lg%20text-text-secondary%22%7D" className="text-base md:text-lg text-text-secondary">
                {SECTION_CONTENT.audioDemo.subheading}
              </p>
            </div>

            {/* Main Demo Area - Vertical Stack for Mobile, Orb Layout for Desktop */}
            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1551:12" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1551" data-component-end-line="1777" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
              {/* Desktop Layout - Original Orb Design (hidden on mobile) */}
              <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1553:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1553" data-component-end-line="1671" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20md%3Ablock%20relative%20min-h-%5B500px%5D%20lg%3Amin-h-%5B300px%5D%20pt-32%20lg%3Apt-40%22%7D" className="hidden md:block relative min-h-[500px] lg:min-h-[300px] pt-32 lg:pt-40">
                {/* Central AI Orb */}
                <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1555:16" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1555" data-component-end-line="1586" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-1%2F2%20left-1%2F2%20transform%20-translate-x-1%2F2%20-translate-y-1%2F2%20z-10%22%7D" className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
                  <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1556:18" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1556" data-component-end-line="1585" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
                    {/* Outer glow rings */}
                    <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1558:20" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1558" data-component-end-line="1560" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`absolute -inset-8 rounded-full bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-blue-500/20 blur-2xl transition-all duration-500 ${
                      playingDemo ? 'animate-pulse scale-110' : 'scale-100'
                    }`} />
                    
                    {/* Main orb */}
                    <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1563:20" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1563" data-component-end-line="1584" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`relative w-48 h-48 rounded-full bg-gradient-to-br from-blue-500 via-blue-600 to-purple-600 flex items-center justify-center shadow-2xl transition-all duration-300 ${
                      playingDemo ? 'scale-110 shadow-blue-500/50' : 'scale-100'
                    }`}>
                      {/* Waveform animation */}
                      {playingDemo && !isPaused ? (
                        <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1568:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1568" data-component-end-line="1580" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20gap-1.5%22%7D" className="flex items-center justify-center gap-1.5">
                          {[20, 35, 25, 40, 30, 38, 22].map((height, i) => (
                            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1570:28" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1570" data-component-end-line="1578" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-1.5%20bg-white%20rounded-full%22%7D"
                              key={i}
                              className="w-1.5 bg-white rounded-full"
                              style={{
                                animation: 'waveform 1s ease-in-out infinite',
                                animationDelay: `${i * 0.1}s`,
                                height: `${height}px`
                              }}
                            />
                          ))}
                        </div>
                      ) : (
                        <Icon data-component-id="src/app/landing-page/components/SolutionSection.tsx:1582:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1582" data-component-end-line="1582" data-component-file="SolutionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22SpeakerWaveIcon%22%2C%22className%22%3A%22text-white%22%7D" name="SpeakerWaveIcon" size={56} className="text-white" />
                      )}
                    </div>
                  </div>
                </div>

                {/* Demo Cards - Desktop Position */}
                <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1589:16" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1589" data-component-end-line="1670" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20w-full%20max-w-6xl%20mx-auto%22%7D" className="relative w-full max-w-6xl mx-auto">
                  {DEMO_CARDS.map((demo, index) => {
                    const isActive = playingDemo === demo.id && !isPaused;
                    const isLoading = isAudioLoading && playingDemo === demo.id;

                    const positions = [
                      'top-4 left-8',
                      'top-4 right-8',
                      'bottom-4 left-8',
                      'bottom-4 right-8'
                    ];

                    return (
                      <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1602:22" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1602" data-component-end-line="1667" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                        key={demo.id}
                        className={`absolute ${positions[index]} w-[calc(50%-180px)] max-w-xs`}
                        onClick={() => handlePlayDemo(demo.id)}
                      >
                        <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1607:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1607" data-component-end-line="1666" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                          className={`bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border ${
                            isActive
                              ? 'border-blue-500 shadow-blue-500/20 scale-105'
                              : 'border-gray-100 hover:border-blue-200'
                          }`}
                        >
                          <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1614:26" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1614" data-component-end-line="1649" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-4%22%7D" className="flex items-center gap-4">
                            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1615:28" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1615" data-component-end-line="1621" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                              isActive 
                                ? 'bg-blue-600 shadow-lg shadow-blue-500/30' 
                                : 'bg-blue-500 hover:bg-blue-600'
                            }`}>
                              <Icon data-component-id="src/app/landing-page/components/SolutionSection.tsx:1620:30" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1620" data-component-end-line="1620" data-component-file="SolutionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-white%22%7D" name={demo.icon as any} size={24} className="text-white" />
                            </div>

                            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1623:28" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1623" data-component-end-line="1630" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%20min-w-0%22%7D" className="flex-1 min-w-0">
                              <h4 data-component-id="src/app/landing-page/components/SolutionSection.tsx:1624:30" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1624" data-component-end-line="1626" data-component-file="SolutionSection.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22text-base%20font-bold%20text-gray-900%20mb-1%20leading-tight%22%7D" className="text-base font-bold text-gray-900 mb-1 leading-tight">
                                {demo.title}
                              </h4>
                              <p data-component-id="src/app/landing-page/components/SolutionSection.tsx:1627:30" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1627" data-component-end-line="1629" data-component-file="SolutionSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20text-gray-600%20leading-snug%20line-clamp-2%22%7D" className="text-xs text-gray-600 leading-snug line-clamp-2">
                                {demo.description}
                              </p>
                            </div>

                            <button data-component-id="src/app/landing-page/components/SolutionSection.tsx:1632:28" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1632" data-component-end-line="1648" data-component-file="SolutionSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                              className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                                isActive
                                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/30'
                                  : 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-md'
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                handlePlayDemo(demo.id);
                              }}
                            >
                              {isLoading ? (
                                <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1644:32" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1644" data-component-end-line="1644" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-5%20h-5%20border-2%20border-white%20border-t-transparent%20rounded-full%20animate-spin%22%7D" className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                              ) : (
                                <Icon data-component-id="src/app/landing-page/components/SolutionSection.tsx:1646:32" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1646" data-component-end-line="1646" data-component-file="SolutionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-white%22%7D" name={isActive ? "PauseIcon" : "PlayIcon"} size={16} className="text-white" />
                              )}
                            </button>
                          </div>

                          {isActive && (
                            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1652:28" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1652" data-component-end-line="1664" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-4%20pt-4%20border-t%20border-blue-100%22%7D" className="mt-4 pt-4 border-t border-blue-100">
                              <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1653:30" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1653" data-component-end-line="1663" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%22%7D" className="flex items-center justify-between">
                                <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1654:32" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1654" data-component-end-line="1659" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-2%22%7D" className="flex items-center gap-2">
                                  <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1655:34" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1655" data-component-end-line="1655" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-2%20h-2%20bg-blue-600%20rounded-full%20animate-pulse%22%7D" className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" />
                                  <span data-component-id="src/app/landing-page/components/SolutionSection.tsx:1656:34" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1656" data-component-end-line="1658" data-component-file="SolutionSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xs%20font-semibold%20text-blue-600%22%7D" className="text-xs font-semibold text-blue-600">
                                    {SECTION_CONTENT.playingIndicator}
                                  </span>
                                </div>
                                <span data-component-id="src/app/landing-page/components/SolutionSection.tsx:1660:32" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1660" data-component-end-line="1662" data-component-file="SolutionSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xs%20text-gray-500%20font-medium%22%7D" className="text-xs text-gray-500 font-medium">
                                  {demo.duration}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Mobile Layout - Vertical Stack (visible only on mobile) */}
              <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1674:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1674" data-component-end-line="1776" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22md%3Ahidden%20space-y-4%22%7D" className="md:hidden space-y-4">
                {/* Central AI Orb for Mobile */}
                <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1676:16" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1676" data-component-end-line="1704" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20mb-8%22%7D" className="flex justify-center mb-8">
                  <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1677:18" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1677" data-component-end-line="1703" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
                    <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1678:20" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1678" data-component-end-line="1680" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`absolute -inset-6 rounded-full bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-blue-500/20 blur-xl transition-all duration-500 ${
                      playingDemo ? 'animate-pulse scale-110' : 'scale-100'
                    }`} />
                    
                    <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1682:20" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1682" data-component-end-line="1702" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`relative w-32 h-32 rounded-full bg-gradient-to-br from-blue-500 via-blue-600 to-purple-600 flex items-center justify-center shadow-2xl transition-all duration-300 ${
                      playingDemo ? 'scale-110 shadow-blue-500/50' : 'scale-100'
                    }`}>
                      {playingDemo && !isPaused ? (
                        <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1686:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1686" data-component-end-line="1698" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20gap-1%22%7D" className="flex items-center justify-center gap-1">
                          {[20, 35, 25, 40, 30, 38, 22].map((height, i) => (
                            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1688:28" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1688" data-component-end-line="1696" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-1%20bg-white%20rounded-full%22%7D"
                              key={i}
                              className="w-1 bg-white rounded-full"
                              style={{
                                animation: 'waveform 1s ease-in-out infinite',
                                animationDelay: `${i * 0.1}s`,
                                height: `${height}px`
                              }}
                            />
                          ))}
                        </div>
                      ) : (
                        <Icon data-component-id="src/app/landing-page/components/SolutionSection.tsx:1700:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1700" data-component-end-line="1700" data-component-file="SolutionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22SpeakerWaveIcon%22%2C%22className%22%3A%22text-white%22%7D" name="SpeakerWaveIcon" size={48} className="text-white" />
                      )}
                    </div>
                  </div>
                </div>

                {/* Vertically Stacked Demo Cards */}
                {DEMO_CARDS.map((demo) => {
                  const isActive = playingDemo === demo.id && !isPaused;
                  const isLoading = isAudioLoading && playingDemo === demo.id;

                  return (
                    <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1712:20" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1712" data-component-end-line="1773" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                      key={demo.id}
                      onClick={() => handlePlayDemo(demo.id)}
                      className={`bg-white rounded-2xl p-5 shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer border ${
                        isActive
                          ? 'border-blue-500 shadow-blue-500/20 scale-[1.02]'
                          : 'border-gray-100 hover:border-blue-200'
                      }`}
                    >
                      <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1721:22" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1721" data-component-end-line="1756" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-4%22%7D" className="flex items-center gap-4">
                        <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1722:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1722" data-component-end-line="1728" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300 ${
                          isActive 
                            ? 'bg-blue-600 shadow-lg shadow-blue-500/30' 
                            : 'bg-blue-500 hover:bg-blue-600'
                        }`}>
                          <Icon data-component-id="src/app/landing-page/components/SolutionSection.tsx:1727:26" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1727" data-component-end-line="1727" data-component-file="SolutionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-white%22%7D" name={demo.icon as any} size={24} className="text-white" />
                        </div>

                        <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1730:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1730" data-component-end-line="1737" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%20min-w-0%22%7D" className="flex-1 min-w-0">
                          <h4 data-component-id="src/app/landing-page/components/SolutionSection.tsx:1731:26" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1731" data-component-end-line="1733" data-component-file="SolutionSection.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22text-base%20font-bold%20text-gray-900%20mb-1%22%7D" className="text-base font-bold text-gray-900 mb-1">
                            {demo.title}
                          </h4>
                          <p data-component-id="src/app/landing-page/components/SolutionSection.tsx:1734:26" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1734" data-component-end-line="1736" data-component-file="SolutionSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-gray-600%22%7D" className="text-sm text-gray-600">
                            {demo.description}
                          </p>
                        </div>

                        <button data-component-id="src/app/landing-page/components/SolutionSection.tsx:1739:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1739" data-component-end-line="1755" data-component-file="SolutionSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                          className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                            isActive
                              ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/30'
                              : 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-md'
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePlayDemo(demo.id);
                          }}
                        >
                          {isLoading ? (
                            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1751:28" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1751" data-component-end-line="1751" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-5%20h-5%20border-2%20border-white%20border-t-transparent%20rounded-full%20animate-spin%22%7D" className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                          ) : (
                            <Icon data-component-id="src/app/landing-page/components/SolutionSection.tsx:1753:28" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1753" data-component-end-line="1753" data-component-file="SolutionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-white%22%7D" name={isActive ? "PauseIcon" : "PlayIcon"} size={18} className="text-white" />
                          )}
                        </button>
                      </div>

                      {isActive && (
                        <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1759:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1759" data-component-end-line="1771" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-4%20pt-4%20border-t%20border-blue-100%22%7D" className="mt-4 pt-4 border-t border-blue-100">
                          <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1760:26" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1760" data-component-end-line="1770" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%22%7D" className="flex items-center justify-between">
                            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1761:28" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1761" data-component-end-line="1766" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-2%22%7D" className="flex items-center gap-2">
                              <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1762:30" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1762" data-component-end-line="1762" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-2%20h-2%20bg-blue-600%20rounded-full%20animate-pulse%22%7D" className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" />
                              <span data-component-id="src/app/landing-page/components/SolutionSection.tsx:1763:30" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1763" data-component-end-line="1765" data-component-file="SolutionSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xs%20font-semibold%20text-blue-600%22%7D" className="text-xs font-semibold text-blue-600">
                                {SECTION_CONTENT.playingIndicator}
                              </span>
                            </div>
                            <span data-component-id="src/app/landing-page/components/SolutionSection.tsx:1767:28" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1767" data-component-end-line="1769" data-component-file="SolutionSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xs%20text-gray-500%20font-medium%22%7D" className="text-xs text-gray-500 font-medium">
                              {demo.duration}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Trust Note with demo disclaimer */}
            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1780:12" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1780" data-component-end-line="1787" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-16%20text-center%20space-y-3%22%7D" className="mt-16 text-center space-y-3">
              <p data-component-id="src/app/landing-page/components/SolutionSection.tsx:1781:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1781" data-component-end-line="1783" data-component-file="SolutionSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-text-secondary%20max-w-2xl%20mx-auto%20italic%22%7D" className="text-sm text-text-secondary max-w-2xl mx-auto italic">
                {SECTION_CONTENT.audioDemo.trustNote}
              </p>
              <p data-component-id="src/app/landing-page/components/SolutionSection.tsx:1784:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1784" data-component-end-line="1786" data-component-file="SolutionSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20text-muted-foreground%20max-w-xl%20mx-auto%22%7D" className="text-xs text-muted-foreground max-w-xl mx-auto">
                {SECTION_CONTENT.audioDemo.disclaimer}
              </p>
            </div>
          </div>
        )}

        {activeDemo === 'dashboard' && (
          <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1792:10" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1792" data-component-end-line="1829" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-6xl%20mx-auto%22%7D" className="max-w-6xl mx-auto">
            <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1793:12" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1793" data-component-end-line="1828" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-background%20rounded-2xl%20shadow-enterprise-md%20overflow-hidden%22%7D" className="bg-background rounded-2xl shadow-enterprise-md overflow-hidden">
              <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1794:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1794" data-component-end-line="1801" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
                <AppImage data-component-id="src/app/landing-page/components/SolutionSection.tsx:1795:16" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1795" data-component-end-line="1799" data-component-file="SolutionSection.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22w-full%20h-auto%22%7D"
                  src={DASHBOARD_IMAGE.src}
                  alt={DASHBOARD_IMAGE.alt}
                  className="w-full h-auto"
                />
                <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1800:16" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1800" data-component-end-line="1800" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-gradient-to-t%20from-background%20via-transparent%20to-transparent%22%7D" className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
              </div>

              <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1803:14" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1803" data-component-end-line="1827" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22p-8%22%7D" className="p-8">
                <h3 data-component-id="src/app/landing-page/components/SolutionSection.tsx:1804:16" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1804" data-component-end-line="1806" data-component-file="SolutionSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-2xl%20font-bold%20text-text-primary%20mb-6%22%7D" className="text-2xl font-bold text-text-primary mb-6">
                  {SECTION_CONTENT.dashboard.heading}
                </h3>

                <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1808:16" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1808" data-component-end-line="1826" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20md%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                  {ANALYTICS_CARDS.map((card) => (
                    <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1810:20" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1810" data-component-end-line="1824" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-surface%20rounded-xl%20p-6%20border%20border-border%22%7D" key={card.id} className="bg-surface rounded-xl p-6 border border-border">
                      <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1811:22" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1811" data-component-end-line="1816" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-3%20mb-3%22%7D" className="flex items-center gap-3 mb-3">
                        <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1812:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1812" data-component-end-line="1814" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`w-10 h-10 ${card.iconBgColor} rounded-lg flex items-center justify-center`}>
                          <Icon data-component-id="src/app/landing-page/components/SolutionSection.tsx:1813:26" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1813" data-component-end-line="1813" data-component-file="SolutionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={card.icon as any} size={24} className={card.iconColor} />
                        </div>
                        <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1815:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1815" data-component-end-line="1815" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-3xl%20font-bold%20text-text-primary%22%7D" className="text-3xl font-bold text-text-primary">{card.value}</div>
                      </div>
                      <p data-component-id="src/app/landing-page/components/SolutionSection.tsx:1817:22" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1817" data-component-end-line="1817" data-component-file="SolutionSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-text-secondary%22%7D" className="text-sm text-text-secondary">{card.label}</p>
                      <div data-component-id="src/app/landing-page/components/SolutionSection.tsx:1818:22" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1818" data-component-end-line="1823" data-component-file="SolutionSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-1%20mt-2%22%7D" className="flex items-center gap-1 mt-2">
                        <Icon data-component-id="src/app/landing-page/components/SolutionSection.tsx:1819:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1819" data-component-end-line="1819" data-component-file="SolutionSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={card.trend.icon as any} size={16} className={card.trend.color} />
                        <span data-component-id="src/app/landing-page/components/SolutionSection.tsx:1820:24" data-component-path="src/app/landing-page/components/SolutionSection.tsx" data-component-line="1820" data-component-end-line="1822" data-component-file="SolutionSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`text-xs font-semibold ${card.trend.color}`}>
                          {card.trend.value}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default SolutionSection;